import TickerService from '@resn/gozer-services/ticker-service';

let tl;
const TextureCache = new Map();

const pushingQueue = [];
let _renderer;

const queue = (d, done) => {
    pushingQueue.push({ d, done });
};

const checkQueue = () => {
    if (pushingQueue.length) {
        const { d, done } = pushingQueue.pop();

        _renderer.initTexture(d);
        done();
    }
};

TickerService.add(checkQueue);

export function initLoadTexture(renderer) {
    _renderer = renderer;
}

export default function loadTexture(url) {
    if (!_renderer) throw new Error('loadTexture not initialised');

    if (TextureCache.has(url)) {
        return Promise.resolve(TextureCache.get(url));
    }

    return import('three')
        .catch(() => {
            console.warn('Could not load TextureLoader, is three installed?');
        })
        .then(({ TextureLoader, Math }) => {
            if (!tl) tl = new TextureLoader();

            return new Promise((resolve) => {
                tl.load(
                    url,
                    (d) => {
                        if (!Math.isPowerOfTwo(d.image.width) || !Math.isPowerOfTwo(d.image.height)) {
                            if (__ENV__ === 'local' || __ENV__ === 'development') {
                                console.warn(`>>> "${url}" image size is not power of 2 <<<`);
                            }
                        }

                        d.needsUpdate = true;
                        queue(d, () => {
                            resolve(d);
                        });
                        TextureCache.set(url, d);
                    },
                    null,
                );
            });
        });
}
